module.exports = __webpack_public_path__ + "static/img/applets_code.13225aa.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/applets_code.jpg
// module id = +27s
// module chunks = 16